<template>
  <layout-component
    headerTitle="SOLICITUDES - GESTIÓN DE TIQUETES"
    :showLocation="false"
  >
    <template #container>
      <div style="display: flex; left: 15px; margin-bottom: 10px" class="mt-3">
        <label class="mr-2 breadcrumb-link"
          ><button
            class="mt-0 p-0 pb-1 d-flex align-items-center breadcrumb-link back"
            style="
              border: none;
              background-color: transparent;
              font-size: 16px;
            "
            @click.prevent="backGes"
          >
            Volver
          </button></label
        >
      </div>
      <b-overlay :show="processing" rounded="sm">
        <template #overlay>
          <OverlayButton clase="overlay-md"> </OverlayButton>
        </template>
        <b-tabs v-model="tabIndex">
          <b-tab v-for="(item, index) in itemsRequestCollaborators" :key="item.id">
            <template #title> {{ item?.name }} </template>
            <div v-if="tabIndex === index">
              <TabComponent :managementId="item?.id" />
            </div>
          </b-tab>
        </b-tabs>
      </b-overlay>
    </template>
  </layout-component>
</template>
<script>
import { getLicense } from "@/services/modules/permisos-sindicales/v2/licenses/gestor-impuestos/service";
import TabComponent from "./components/TabComponent.vue";
import OverlayButton from "@/components/core/overlay/overlay-button.vue";
export default {
  name: "management",
  components: {
    layoutComponent: () =>
      import("@/layouts/modules/permisos-sindicales/v2/app.vue"),
    TabComponent,
    OverlayButton,
  },
  data: () => ({
    tabIndex: 0,
    managementId: 6916,
    processing: true,
    license: [],
  }),
  computed: {
    licenseId() {
      return Number(this.$route.params.id || 0);
    },
    itemsRequestCollaborators() {
      return this.license.length ? this.license[0].tickets : [];
    },
  },
  methods: {
    backGes() {
      this.$router.push({
        name: "request-of-gestor-impuestos-show",
        params: { id: this.licenseId },
      });
    }
  },
  mounted() {
    // ## CARGA LA LICENCIA
    getLicense(this.licenseId)
      .then(({ result }) => {
        this.license.push(result);
      })
      .finally(() => (this.processing = false));
  },
};
</script>

<style lang="scss">
.card {
  word-wrap: normal;
}
// ## TITULO DE LA PAGINA
.title {
  padding: 8px 0 8px 8px;
  border-radius: 4px;
  gap: 40px;
  background-color: rgba(236, 239, 241, 1);
  font-family: "Ubuntu", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0;
  text-align: left;
  color: rgba(38, 50, 56, 1);
}
// ## TAB'S
.nav-link.active {
  color: rgba(14, 51, 58, 1) !important;
  border-bottom: 3px solid rgba(14, 51, 58, 1) !important;
  font-family: "Ubuntu", sans-serif;
  font-size: 12px;
  font-weight: 700;
  line-height: 16px;
  letter-spacing: 0;
  text-align: left;
}
.tab-title {
  font-family: "Ubuntu", sans-serif;
  font-size: 16px;
  font-weight: 700;
  line-height: 28px;
  letter-spacing: 0;
  text-align: left;
  color: rgba(28, 103, 118, 1);
  padding-top: 10px;
}
//## ERRORS
.text-size-error {
  font-size: 0.875em;
}

//## SUBIDA DEL ARCHIVO
.content-file-pdf {
  border: 1px solid #eceff1;
  padding: 1.5rem;
  border-radius: 4px;
  display: table;
  width: 100%;
  font-size: 14px;
}
.content-file-pdf .content-icon {
  width: 50px;
  height: 50px;
  background-color: #e6f7ff;
  border-radius: 50%;
  display: table-cell;
  padding: 0.2rem;
}
.content-icon .content-file-icon {
  background-image: url("../../../../../assets/modules/permisos-sindicales/icons/uploader/pdf.svg");
  background-repeat: no-repeat;
  background-size: contain;
  height: 100%;
  width: 100%;
  display: block;
}
.content-file-text {
  display: table-cell;
  padding-left: 1rem;
  vertical-align: middle;
}
.content-file-text .text-green {
  color: #0c9e42;
}
.content-file-text-small {
  display: table-cell;
  text-align: right;
  color: #78909c;
  vertical-align: top;
}
.content-file-text .text-gray {
  color: #78909c;
  font-size: 12px;
}
.remove-file {
  vertical-align: initial;
  cursor: pointer;
}
</style>
